import React from 'react';
import { useSelector } from 'react-redux';
import c from 'classnames';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import { Logo, Button } from '../../components';
import FooterMenu from '../Menu/Footer';

import './style.scss';

const Footer = ({ entityId, entityTypeTarget }) => {

  const enityFieldLogo = useSelector((state) => state.getIn(['node', entityId, 'field_logo_inverted', '0'], null));
  const enityFieldOrganization = useSelector((state) => state.getIn(['node', entityId, 'field_organization', '0', 'entity'], null));

  const refFieldLogo = useSelector((state) => state.getIn(['node', entityId, 'field_municipality', '0', 'entity', 'field_logo_inverted', '0'], null));
  const refFieldOrganization = useSelector((state) => state.getIn(['node', entityId, 'field_municipality', '0', 'entity', 'field_organization', '0', 'entity'], null));

  const fieldPrivacyStatement = useSelector((state) => state.getIn(['node', entityId, 'field_organization', '0', 'entity', 'field_privacy_statement', '0'], null));
  const fieldPrivacyStatementRef = useSelector((state) => (
    state.getIn(['node', entityId, 'field_municipality', '0', 'entity', 'field_organization', '0', 'entity', 'field_privacy_statement', '0'], null)));

  let source;
  let alt;
  let name;
  let phone;
  let info;
  let email;

  if (entityTypeTarget === 'municipality') {
    source = enityFieldLogo.get('url');
    alt = enityFieldLogo.get('alt');
    name = enityFieldOrganization.getIn(['name', 0, 'value']);
    phone = enityFieldOrganization.getIn(['field_phonenumber', 0, 'value']);
    info = enityFieldOrganization.getIn(['field_info', 0, 'value']);
    email = enityFieldOrganization.getIn(['field_email', 0, 'value']);

  } else if (refFieldLogo) {
    source = refFieldLogo.get('url');
    alt = refFieldLogo.get('alt');
    name = refFieldOrganization.getIn(['name', 0, 'value']);
    phone = refFieldOrganization.getIn(['field_phonenumber', 0, 'value']);
    info = refFieldOrganization.getIn(['field_info', 0, 'value']);
    email = refFieldOrganization.getIn(['field_email', 0, 'value']);
  }

  const classNames = c('Footer', {
    'Footer--municipality': refFieldLogo || (entityTypeTarget === 'municipality'),
  });

  return (
    <div className={classNames} id="footer">
      <Container>
        <div className="Footer__main">
          <div className="Footer__main__left">
            <div className="Footer__main__left__logo-odp">
              <Logo secondary={!(refFieldLogo || (entityTypeTarget === 'municipality'))} path={source} alt={alt} municipality />
            </div>
          </div>
          <div className="Footer__main__right">
            {(entityTypeTarget === 'municipality' || refFieldLogo) && (
              <div className="Footer__main__right__municipality">
                <div className="organization-name">{name}</div>
                <div><a className="organization-link" href={`tel:${phone}`}><span>T</span>{phone}</a></div>
                {info && <div className="organization-link">{info}</div>}
                <div><a className="organization-link" href={`mailto:${email}`}><span>E</span><span className="link-decorate">{email}</span></a></div>
              </div>
            )}
            <div className="Footer__main__left__link">
              {fieldPrivacyStatementRef
              && (<Button white secondary forceBlank href={fieldPrivacyStatementRef.get('alias')}>{fieldPrivacyStatementRef.get('title')}</Button>)}
              {fieldPrivacyStatement
              && (<Button white secondary forceBlank href={fieldPrivacyStatement.get('alias')}>{fieldPrivacyStatement.get('title')}</Button>)}
            </div>
          </div>
        </div>
        <div className="Footer__left">
          <FooterMenu />
        </div>
      </Container>
    </div>
  );
};

export default Footer;
